import React from "react"
import axios from "axios"
import { notify } from "react-notify-toast"
import "../Home/model_style.css"
import AvatarEditor from "react-avatar-editor"
import Modal from "../../Components/Modal/Modal"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import CancelButton from "../../Components/Buttons/CancelButton"
import { API } from "../../API"
import { handleLogErrorToSlack } from "../../Helper"

const rowStyle = {
  display: "flex",
}

const columnStyle = {
  flex: "50%",
  padding: "5px",
}

class ImageCrops extends React.Component {
  constructor(props) {
    super(props)
    const src = ""
    this.state = {
      preview: null,
      src,
      file: this.props.imageSrc,
      fileName: this.props.imageSrc.name,
      newFileName: new Date().getDate(),
      oldFileName: null,
      editor: null,
      fileType: this.props.fileType,
      fileSize: "",
      url: "",
      height: this.props.height,
      width: this.props.width,
      rotate: 0,
    }
  }

  urltoFile = (url, filename, mimeType) => {
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1]
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer()
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType })
      })
  }

  // Use this for Zoom in/out
  onScaleChange = (scaleChangeEvent) => {
    const scaleValue = parseFloat(scaleChangeEvent.target.value)
    this.setState({ scaleValue })
  }

  setEditorRef = (editor) => {
    this.setState({ editor })
  }

  // Crops image
  onCrop = () => {
    const { editor } = this.state
    if (editor !== null) {
      const url = editor.getImage().toDataURL()
      this.setState({ userProfilePic: url })

      this.urltoFile(url, this.state.Name).then((file) => {
        this.setState({ fileSize: file.size })
        this.setState({ file: file })
      })
    }
  }

  onBeforeFileLoad = (elem) => {
    if (elem.target.files[0].type === "application/pdf") {
      elem.target.value = ""
      notify.show("Invalid file format, please select file type other than pdf")
    }
  }

  // Rotates image to the right 90 degree
  rotate90Deg = () => {
    this.setState({
      rotate: this.state.rotate + 90,
    })
  }

  // Saves the file to AWS and Mongo
  saveFile = () => {
    this.onCrop()

    const file = this.state.file
    let fileParts = this.state.fileName.split(".")
    let fileType = fileParts[1]
    let fileName = this.state.fileType
    API.uploadFileToS3({
      fileName: fileName,
      fileType: fileType,
      _id: this.props.user._id,
    })
      .then((response) => {
        const returnData = response.data.data.returnData
        const signedRequest = returnData.signedRequest
        const return_url = returnData.url
        const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
        const suffix = return_url.substring(cut_length, return_url.length)
        // const prefix = "https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?path="
        const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=" 
        const url = prefix+suffix;
        this.setState({ url: url })
        console.log("Signed request", signedRequest)
        // Put the fileType in the headers for the upload
        const options = {
          headers: {
            "Content-Type": fileType,
          },
        }
        axios
          .put(signedRequest, file, options)
          .then((response2) => {
            this.props.action(this.state.fileName, url)
            this.props.togglePopup()
            notify.show("File uploaded successfully")
          })
          .catch((error) => {
            handleLogErrorToSlack(error, true)
            console.log(error)
            alert("ERROR " + JSON.stringify(error))
          })
      })
      .catch((error) => {
        notify.show(JSON.stringify(error), "error")
      })
  }

  onCropDefault(preview) {
    this.setState({ defaultPreview: preview })
  }

  onFileLoad = (e) => {
    this.setState({ file: e })
    this.setState({ Name: e.name })
  }

  onhide = () => {
    //this.setState({ showPopup: false });
    this.props.togglePopup()
  }

  render() {
    return (
      <Modal
        show={true}
        className="avatar-upload-modal"
        header="Upload a Professional Photo"
        onClose={this.onhide}
      >
        <div className="row upload-avatar-form-box">
          <div className="upload-avatar-form">
            <div style={rowStyle}>
              <div style={columnStyle}>
                <AvatarEditor
                  image={this.props.imageSrc}
                  border={15}
                  scale={this.state.scaleValue}
                  rotate={this.state.rotate}
                  width={300}
                  height={200}
                  ref={this.setEditorRef}
                  className="cropCanvas"
                />
              </div>
              {this.state.userProfilePic && <div style={columnStyle}>
                <img src={this.state.userProfilePic} alt=" " />
              </div>}
            </div>

            <ConfirmButton onClick={this.onCrop} style={{ margin: "auto" }}>
              Crop
            </ConfirmButton>
            <ConfirmButton onClick={this.rotate90Deg}>Rotate</ConfirmButton>
          </div>
        </div>
        <div className="row upload-button-box">
          <div className="col-md-6">
            <CancelButton onClick={this.onhide}>Cancel</CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton onClick={this.saveFile}>Update</ConfirmButton>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ImageCrops
